export default __webpack_public_path__ + "11026c6af3d37a90997f9214231ebcf8.svg";